import { z } from "zod";

export const documentoRelacionadoSchema = z.array(
  z.object({
    tipoDocumento: z.string(),
    tipoGeneracion: z.number(), // podés validar con z.enum([1, 2]) si lo querés más estricto
    numeroDocumento: z.string(),
    fechaEmision: z.string(),
  })
);

export const facturaBaseSchema = z
  .object({
    identificacion: z.any(),
    documentoRelacionado: documentoRelacionadoSchema.optional().default(null),
    ventaTercero: z.any().optional().default(null),
    emisor: z.any().optional().default(null),
    receptor: z.any().optional().default(null),
    cuerpoDocumento: z.any().optional().default([]),
    extension: z.any().optional().default(null),
    apendice: z.any().optional().default(null),
  })
  .strip();

export const emisorBaseSchema = z.object({
  nit: z.string().regex(/^[A-Z0-9]{9,14}$/i, {
    message: "NIT invalido, permitido: alfanumerico, de 9 a 14 caracteres",
  }),
  nrc: z.string().regex(/^[A-Z0-9]{2,8}$/i, {
    message: "NRC inválido, debe ser alfanumérico de 2 a 8 caracteres",
  }),
  nombre: z.string().min(3).max(200),
  codActividad: z.string().min(2).max(6),
  descActividad: z.string().min(1).max(150),
  nombreComercial: z.string().min(1).max(150).nullable(),
  tipoEstablecimiento: z.enum(["01", "02", "04", "07", "20"]),
  direccion: z.object({
    departamento: z.string().regex(/^[A-Z0-9]{2}$/i, {
      message: "Departamento inválido, debe ser alfanumérico de 2 caracteres",
    }),
    municipio: z.string().regex(/^[A-Z0-9]{2}$/i, {
      message: "Municipio inválido, debe ser alfanumérico de 2 caracteres",
    }),
    complemento: z.string().min(1).max(200),
  }),
  telefono: z.string().min(8).max(30),
  correo: z.string().email().min(3).max(100),
  codEstableMH: z
    .string()
    .regex(/^[A-Z0-9]{4}$/i, { message: "Código Establecimiento MH inválido, debe ser alfanumérico de 4 caracteres" })
    .nullable(),
  codPuntoVentaMH: z
    .string()
    .regex(/^[A-Z0-9]{4}$/i, { message: "Código Punto de Venta MH inválido, debe ser alfanumérico de 4 caracteres" })
    .nullable(),
  codEstable: z
    .string()
    .regex(/^[A-Z0-9]{4}$/i, {
      message: "Código Establecimiento inválido, debe ser alfanumérico de 4 caracteres",
    })
    .nullable(),
  codPuntoVenta: z
    .string()
    .regex(/^[A-Z0-9]{1,15}$/i, {
      message: "Código Punto de Venta inválido, debe ser alfanumérico de 1 a 15 caracteres",
    })
    .nullable(),
});
